import React, { PureComponent } from "react";
import { Treemap, ResponsiveContainer, Tooltip } from "recharts";

const TEXT_COLOR = "#FFFCF8";
const MIN_WIDTH_FOR_TEXT = 100;
const MIN_HEIGHT_FOR_TEXT = 30;

class CustomizedContent extends PureComponent {
    render() {
        const {
            root,
            depth,
            x,
            y,
            width,
            height,
            index,
            payload,
            rank,
            name,
            color,
        } = this.props;

        const showTextInside = depth === 1 && width > MIN_WIDTH_FOR_TEXT && height > MIN_HEIGHT_FOR_TEXT;

        return (
            <g>
                <rect
                    x={x}
                    y={y}
                    width={width}
                    height={height}
                    style={{
                        fill: color,
                        stroke: "#fff",
                        strokeWidth: 2 / (depth + 1e-10),
                        strokeOpacity: 1 / (depth + 1e-10),
                    }}
                />
                {showTextInside ? (
                    <text
                        x={x + width / 2}
                        y={y + height / 2 + 7}
                        textAnchor="middle"
                        fill={TEXT_COLOR}
                        fontSize={16}
                    >
                        {name}
                    </text>
                ) : null}
                {depth === 1 ? (
                    <text
                        x={x + 4}
                        y={y + 18}
                        fill={TEXT_COLOR}
                        fontSize={16}
                        fillOpacity={0.9}
                    >
                        {index + 1}
                    </text>
                ) : null}
            </g>
        );
    }
}

const OverviewChart = ({ items }) => {
    const CustomTooltip = ({ active, payload, items }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip"
                style={{
                    backgroundColor: "rgba(255, 255, 255, 0.85)", // White background with 85% opacity
                    padding: "10px",
                    border: "1px solid #cccccc", // Optional: add a light border
                    borderRadius: "4px", // Optional: round the corners
                    boxShadow: "2px 2px 5px rgba(0,0,0,0.1)", // Optional: add a subtle shadow
                }}
                >
                    <p style={{ color: "black", marginTop: "10px", fontWeight: 400, fontSize: "12px" }}>
                        {`Problem : ${payload[0].payload.name}`}
                        <br></br>
                        {`Session Count : ${payload[0].payload.size}`}
                        <br></br>
                        {`Users Count : ${payload[0].payload.count}`}
                    </p>
                </div>
            );
        }

        return null;
    };
    return (
        <ResponsiveContainer width="100%" height="100%">
            <Treemap
                width={400}
                height={200}
                data={items}
                dataKey="size"
                ratio={4 / 3}
                stroke="#ffffff"
                strokeWidth="0"
                fill="#8884d8"
                content={<CustomizedContent />}
            >
                <Tooltip content={<CustomTooltip />} />
            </Treemap>
        </ResponsiveContainer>
    );
};

export default OverviewChart;